import { Routes, RouterModule } from "@angular/router";
import { ModuleWithProviders } from "@angular/core";
import { SegurGuard } from "./servicios/segur.guard";
import { PortadaComponent } from "./portada/portada.component";
import { acercadeComponent } from "./Acerca de/acercade.component";
import { LoginComponent } from "./login/login.component";
import { MdfclaveComponent } from "./mdfclave/mdfclave.component";
import { FichacapComponent } from "./fichacap/fichacap.component";
import { FichacaplisComponent } from "./fichacap/fichacaplis.component";
import { FichacapimpComponent } from "./fichacap/fichacapimp.component";
import { EntregasComponent } from "./entregas/entregas.component";
import { EntregalisComponent } from "./entregas/entregalis.component";
import { EntregaimpComponent } from "./entregas/entregaimp.component";
import { EntregagrfComponent } from "./entregas/entregagrf.component";
import { AnticipoComponent } from "./anticipo/anticipo.component";
import { AnticipolisComponent } from "./anticipo/anticipolis.component";
import { AnticipoimpComponent } from "./anticipo/anticipoimp.component";
import { LiquidaComponent } from "./liquida/liquida.component";
import { LiquidalisComponent } from "./liquida/liquidalis.component";
import { LiquidaimpComponent } from "./liquida/liquidaimp.component";
import { FacturaComponent } from "./factura/factura.component";
import { FactulisComponent } from "./factura/factulis.component";
import { FactuimpComponent } from "./factura/factuimp.component";
import { PiensosComponent } from "./piensos/piensos.component";
import { PiensosgrfComponent } from "./piensos/piensosgrf.component";
import { PiensosimpComponent } from "./piensos/piensosimp.component";
import { piensoslisComponent } from "./piensos/piensoslis.component";
import { AdminGuardService } from "./guards/admin.guard";
import { AdminPanelComponent } from "./admin/adminPanel.component";
import { GestionPiensos } from "./gestionpiensos/gestionpiensos.component";
import { EntregaOpcionComponent } from "./entregas/entregaOpcion.component";
import { PiensosOpcionComponent } from "./piensos/piensosOpcion.component";
import { AdminLisPiensosComponent } from "./admin/adminLisPiensos.component";
import { AdminPiensosForm } from "./admin/adminPiensosForm.component";
import { AdminLisCorderosComponent } from "./admin/adminLisCorderos.component";
import { AdminCorderosFormComponent } from "./admin/adminCorderosForm.component";
import { LayoutComponent } from "./layout.component";

const appRoutes: Routes = [
  { path: "", redirectTo: "/login", pathMatch: "full" },
  {
    path: "adminPanel",
    component: AdminPanelComponent,
    canActivate: [AdminGuardService],
  },
  { path: "portada", component: PortadaComponent },
  { path: "acercade", component: acercadeComponent },
  { path: "login", component: LoginComponent },
  { path: "mdfclave", component: MdfclaveComponent, canActivate: [SegurGuard] },
  { path: "fichacap", component: FichacapComponent, canActivate: [SegurGuard] },
  {
    path: "adminCorderosForm",
    component: AdminCorderosFormComponent,
    canActivate: [SegurGuard],
  },
  {
    path: "adminLisCorderos",
    component: AdminLisCorderosComponent,
    canActivate: [SegurGuard],
  },
  {
    path: "adminPiensosForm",
    component: AdminPiensosForm,
    canActivate: [SegurGuard],
  },
  {
    path: "adminLisPiensos",
    component: AdminLisPiensosComponent,
    canActivate: [SegurGuard],
  },
  {
    path: "piensoOpcion",
    component: PiensosOpcionComponent,
    canActivate: [SegurGuard],
  },
  {
    path: "entregaOpcion",
    component: EntregaOpcionComponent,
    canActivate: [SegurGuard],
  },
  {
    path: "fichacaplis",
    component: FichacaplisComponent,
    canActivate: [SegurGuard],
  },
  {
    path: "fichacapimp",
    component: FichacapimpComponent,
    canActivate: [SegurGuard],
  },
  { path: "entregas", component: EntregasComponent, canActivate: [SegurGuard] },
  {
    path: "entregalis",
    component: EntregalisComponent,
    canActivate: [SegurGuard],
  },
  {
    path: "entregaimp",
    component: EntregaimpComponent,
    canActivate: [SegurGuard],
  },
  {
    path: "entregagrf",
    component: EntregagrfComponent,
    canActivate: [SegurGuard],
  },
  { path: "anticipo", component: AnticipoComponent, canActivate: [SegurGuard] },
  {
    path: "anticipolis",
    component: AnticipolisComponent,
    canActivate: [SegurGuard],
  },
  {
    path: "anticipoimp",
    component: AnticipoimpComponent,
    canActivate: [SegurGuard],
  },
  { path: "liquida", component: LiquidaComponent, canActivate: [SegurGuard] },
  {
    path: "liquidalis",
    component: LiquidalisComponent,
    canActivate: [SegurGuard],
  },
  {
    path: "liquidaimp",
    component: LiquidaimpComponent,
    canActivate: [SegurGuard],
  },
  { path: "factura", component: FacturaComponent, canActivate: [SegurGuard] },
  { path: "factulis", component: FactulisComponent, canActivate: [SegurGuard] },
  { path: "factuimp", component: FactuimpComponent, canActivate: [SegurGuard] },
  { path: "piensos", component: PiensosComponent, canActivate: [SegurGuard] },
  {
    path: "piensosgrf",
    component: PiensosgrfComponent,
    canActivate: [SegurGuard],
  },
  {
    path: "piensosimp",
    component: PiensosimpComponent,
    canActivate: [SegurGuard],
  },
  {
    path: "piensoslis",
    component: piensoslisComponent,
    canActivate: [SegurGuard],
  },
  {
    path: "gestionPiensos",
    component: GestionPiensos,
    canActivate: [SegurGuard],
  },
];

export const routes: ModuleWithProviders<any> = RouterModule.forRoot(appRoutes);
